import { NodeStruct } from '@/types/node-types';
import { apiRequest } from '@/utils/api-request';
import { sanitizeMapCatalog } from '@/pages/workflow/helper/map-control';
import { sanitizeRepeatCatalog } from '@/pages/workflow/helper/repeat-control';

export interface GetNodeListResponse {
  data?: {
    catalog: NodeStruct[];
    success: boolean;
    total_nodes: number;
    websocket_url: string;
    capabilities?: string[] | Record<string, boolean>;
    runtime_capabilities?: string[] | Record<string, boolean>;
  };
  capabilities?: string[] | Record<string, boolean>;
  runtime_capabilities?: string[] | Record<string, boolean>;
  detail?: string;
}

/**
 * Fetches the list of available nodes from the backend and groups them by node_type
 * @param orgId Organization ID
 * @returns Promise containing the grouped node list data
 */
export async function getNodeList(orgId: string): Promise<GetNodeListResponse> {
  try {
    const response = await apiRequest<GetNodeListResponse>({
      url: `/nodes/${orgId}/list-nodes`,
      target: 'workflow',
      method: 'POST',
    });

    if (response?.detail) {
      return {
        detail: response.detail || 'Failed to fetch node list',
      };
    }

    // const sampleResponse: GetNodeListResponse = {
    //   data: {
    //     catalog: sampleNodeList.catalog,
    //     success: true,
    //     total_nodes: sampleNodeList.total_nodes,
    //   },
    // };

    const typedResponse = response as GetNodeListResponse;
    if (typedResponse.data?.catalog) {
      return {
        ...typedResponse,
        data: {
          ...typedResponse.data,
          catalog: sanitizeRepeatCatalog(
            sanitizeMapCatalog(typedResponse.data.catalog),
          ),
        },
      };
    }
    return typedResponse;
  } catch (error) {
    console.error('Error fetching node list:', error);
    throw error;
  }
}
